/* eslint-disable no-param-reassign */
import React from 'react';

import { Checkbox, Radio } from '@material-ui/core';
import { useField } from 'formik';

import { Container, FormControlOption, ErrorMessage } from './styles';

interface Option {
  value: string;
  label: string;
}

interface SelectButtonProps {
  name: string;
  type: 'radio' | 'checkbox' | 'checkbox-radio';
  options: Option[];
  onChange?: (options: Option[] | null) => void;
}

const SelectButton: React.FC<SelectButtonProps> = ({
  name,
  type,
  options,
  onChange,
}) => {
  const [field, meta, helpers] = useField<Option[] | null>(name);
  const { value: selectedOptions } = field;
  const { error } = meta;
  const { setValue: setSelectedOptions } = helpers;

  const handleSelectedOption = (newOption: Option) => {
    let newSelectedOptions: Option[] | null;
    const hasOption = selectedOptions?.some(
      (option) => option.value === newOption.value,
    );

    if (hasOption) {
      newSelectedOptions =
        selectedOptions && selectedOptions.length > 1
          ? selectedOptions?.filter(
              (option) => option.value !== newOption.value,
            )
          : null;
    } else {
      newSelectedOptions =
        selectedOptions && type !== 'checkbox-radio'
          ? [...selectedOptions, newOption]
          : [newOption];
    }

    if (onChange) {
      onChange(newSelectedOptions);
    }
    setSelectedOptions(newSelectedOptions);
  };

  return (
    <Container>
      {options.map((option) => (
        <FormControlOption
          key={option.value}
          name={option.value}
          control={type === 'radio' ? <Radio /> : <Checkbox />}
          label={option.label}
          checked={selectedOptions?.some((selectedOption) => {
            return selectedOption.value === option.value;
          })}
          onChange={() => handleSelectedOption(option)}
        />
      ))}
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Container>
  );
};

export default SelectButton;
